var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowtieAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59354 9.05947L3.57346 6.18007C2.91069 5.72232 2 6.19015 2 6.98838V17.0116C2 17.8099 2.91069 18.2777 3.57346 17.8199L8.59354 14.9405C7.91214 14.1519 7.5 13.1241 7.5 12C7.5 10.8759 7.91214 9.84814 8.59354 9.05947Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4065 14.9405L20.4265 17.8199C21.0893 18.2777 22 17.8099 22 17.0116V6.98838C22 6.19015 21.0893 5.72232 20.4265 6.18007L15.4065 9.05947C16.0879 9.84814 16.5 10.8759 16.5 12C16.5 13.1241 16.0879 14.1519 15.4065 14.9405Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowtieAlt2);
export default __webpack_public_path__ + "static/media/bowtie-alt-2.60547dfbf9c2216de2e5047e468acf7c.svg";
export { ForwardRef as ReactComponent };